const SpanishBranches: Record<string, string> = {
  // keep lowercase, like dxp-config.json keys
  health: 'salud',
  dental: 'dental',
  pets: 'mascotas',
  life: 'vida',
  travel: 'viajes',
  foreignHealth: 'salud-extranjeros',
  'health-foreign': 'salud-extranjeros',
  home: 'hogar',
  // TODO: actualizar estos ↓↓↓ cuando se sepa como serán
  accidents: 'accidentes',
  hospitalization: 'hospitalization'
}

export default SpanishBranches
